import { render, staticRenderFns } from "./KeyPerformanceIndicatorsPane.vue?vue&type=template&id=54f69aea&"
import script from "./KeyPerformanceIndicatorsPane.vue?vue&type=script&lang=ts&"
export * from "./KeyPerformanceIndicatorsPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports